//region :: Imports ::
import React, {createRef, ReactElement, RefObject} from 'react';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import MForm from '../../Components/Toolkit/Form';
import MPage, {MPageProps} from '../../Toolkit/Components/Shell/Page';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import MComponent from '../../Toolkit/Components/Component';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import MFormSection from '../../Toolkit/Components/Controls/FormSection';
import {MFormOutcome} from '../../Toolkit/Components/Controls/Form';
import WithRouterProps from '../../Toolkit/WithRouterProps';
import withRouter from '../../Toolkit/WithRouter';
import {FieldProps, FormikHelpers} from 'formik';
import * as Yup from 'yup';
import NSwagAdapter from '../../Toolkit/Api/NSwagAdapter';
import {CreateRequestRequest, RequestClient, UpdateRequestRequest} from '../../Api/RequestClients';
import MNSwagClientConfiguration from '../../Toolkit/Api/NSwagClientConfiguration';
import TrafficManagementAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';
import {MNullable, toErrorMessage} from '../../Toolkit/Utils';
import {RequestReply, UpdateRequestValidator} from '../../Api/ControllerTypes/RequestTypes';
import MFormFieldControl from '../../Toolkit/Components/Controls/FormFieldControl';
import MTextBox from '../../Toolkit/Components/Controls/TextBox';
import {Request} from '../../Api/ControllerTypes/RequestTypes';
import MNumericBox from '../../Components/Toolkit/NumericBox';
import MTextArea from '../../Toolkit/Components/Controls/TextArea';
import MDropDown from '../../Toolkit/Components/Controls/DropDown';
import {MDropDownItem} from '../../Toolkit/Components/Controls/DropDownOption';
import MButton from '../../Toolkit/Components/Controls/Button';
import NoteListControl from '../../Components/NoteListControl';
import AuditLogControl from '../../Components/AuditLogControl';
import FileListControl from '../../Components/FileListControl';
import MCalendar from '../../Components/Toolkit/Calendar';
import JobCrewsControl from '../../Components/JobCrewsControl';
import {CreateLockRequest, LockClient} from '../../Api/LockClient';
import SafeDigAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';
import InvoiceControl from '../../Components/InvoiceControl';
import {MBackIconName, MSaveIconName, MSuccessIcon} from '../../Toolkit/Icons';
import EmailConfirmDialog from '../../Dialogs/EmailConfirmDialog';
import MessageDialog from '../../Dialogs/MessageDialog';
import {Divider} from 'primereact/divider';
import OkCancelDialog from '../../Dialogs/OkCancelDialog';
import DrawingControl from '../../Components/DrawingControl';
import MCalendarMulti from '../../Components/Toolkit/CalendarMulti';
import NoParkingDialog from '../../Dialogs/NoParkingDialog';
import {AddAdditionalWorkRequest, JobAssignmentClient} from '../../Api/JobAssignmentClient';
import MAutoComplete from '../../Components/Toolkit/AutoComplete';
import CancellationDialog from '../../Dialogs/CancellationDialog';
import {NoteReply} from '../../Api/ControllerTypes/NoteTypes';
import {CreateNoteRequest, NoteClient} from '../../Api/NoteClient';
import Button from '../../Toolkit/Components/Controls/Button';
import {DfeDataClient, UpdateDfeDataRequest} from '../../Api/DfeDataClient';
import EnumContext from '../../Context/enum-context';
import {Project, ProjectMultiReply} from '../../Api/ControllerTypes/ProjectTypes';
import {ProjectClient} from '../../Api/ProjectClient';

//endregion

/** */
type RouteParams = {
    id: string;
};

/** */
enum PageActions {
    None = 0,
    Saving = 1 << 1,
    Refreshing = 1 << 2
}

/** */
type Props = WithMsalProps & WithRouterProps<RouteParams> & {}

/** */
type State = {
    pageTitle: string;
    pageSubtitle: string;
    page: MPageProps;
    form: {
        id: string;
        data: Request;
        validationSchema: any;
    };
    pageActions: PageActions;
    projectList: Project[];
}

/** */
class EditCommercialPage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private quoteValidationSchema: any = Yup.object().shape({
        exchange: UpdateRequestValidator.exchange,
        slaType: UpdateRequestValidator.slaType,
        projectValue: UpdateRequestValidator.projectValue,
        workDescription: UpdateRequestValidator.workDescription,
        jobEndDate: UpdateRequestValidator.jobEndDate,
        estimatedDays: UpdateRequestValidator.estimatedDays,
        address1: UpdateRequestValidator.address1,
        address2: UpdateRequestValidator.address2,
        address3: UpdateRequestValidator.address3,
        city: UpdateRequestValidator.city,
        county: UpdateRequestValidator.county,
        postcode: UpdateRequestValidator.postcode,
        northing: UpdateRequestValidator.northing,
        easting: UpdateRequestValidator.easting,
        gridReference: UpdateRequestValidator.gridReference,
        quoteValue: UpdateRequestValidator.quoteValue,
        jobType: UpdateRequestValidator.jobType,
        invoiceNumber: UpdateRequestValidator.invoiceNumber,
        addRecipients: UpdateRequestValidator.addRecipient,
        dfeStatus: UpdateRequestValidator.dfeStatus,
        dfePartialReason: UpdateRequestValidator.dfePartialReason
    });

    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_formRef: RefObject<MForm<Request>>;
    private readonly m_jobCrewRef: RefObject<JobCrewsControl>;
    private readonly m_noteListRef: RefObject<NoteListControl>;
    private readonly m_emailConfirmRef: RefObject<EmailConfirmDialog>;
    private readonly m_requestClient: NSwagAdapter<RequestClient>;
    private readonly m_dfeDataClient: NSwagAdapter<DfeDataClient>;
    private readonly m_lockClient: NSwagAdapter<LockClient>;
    private readonly m_jobAssignClient: NSwagAdapter<JobAssignmentClient>;
    private readonly m_noteClient: NSwagAdapter<NoteClient>;
    private readonly m_projectClient: NSwagAdapter<ProjectClient>;
    private readonly m_okCancelDialogRef: RefObject<OkCancelDialog>;
    private readonly m_messageDialogRef: RefObject<MessageDialog>;
    private readonly m_noParkingDialogRef: RefObject<NoParkingDialog>;
    private readonly m_cancelDialogRef: RefObject<CancellationDialog>;
    private m_locationValue: string;
    private m_interval: any = 0;
    private m_noParkingInstall: Date | undefined;
    private m_lockDate: Date;
    
    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_pageRef = createRef<MPage>();
        this.m_formRef = createRef<MForm<Request>>();
        this.m_jobCrewRef = createRef<JobCrewsControl>();
        this.m_noteListRef = createRef<NoteListControl>();
        this.m_emailConfirmRef = createRef<EmailConfirmDialog>();
        this.m_messageDialogRef = createRef<MessageDialog>();
        this.m_noParkingDialogRef = createRef<NoParkingDialog>();
        this.m_cancelDialogRef = createRef<CancellationDialog>();
        this.m_locationValue = '';
        this.m_lockDate = new Date();
        this.m_requestClient = new NSwagAdapter<RequestClient>(new RequestClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_dfeDataClient = new NSwagAdapter<DfeDataClient>(new DfeDataClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_lockClient = new NSwagAdapter<LockClient>(new LockClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_jobAssignClient = new NSwagAdapter<JobAssignmentClient>(new JobAssignmentClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_noteClient = new NSwagAdapter<NoteClient>(new NoteClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_projectClient = new NSwagAdapter<ProjectClient>(new ProjectClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_okCancelDialogRef = createRef<OkCancelDialog>();

        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.getToolbarTemplate = this.getToolbarTemplate.bind(this);
        this.close_Click = this.close_Click.bind(this);
        this.form_onBeforeSubmit = this.form_onBeforeSubmit.bind(this);
        this.form_onSubmit = this.form_onSubmit.bind(this);
        this.form_onAfterSubmit = this.form_onAfterSubmit.bind(this);
        this.form_onError = this.form_onError.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.loadPageData = this.loadPageData.bind(this);
        this.toolbar_onRefreshClick = this.toolbar_onRefreshClick.bind(this);
        this.isNavigateDisabled = this.isNavigateDisabled.bind(this);
        this.isQuoteDisabled = this.isQuoteDisabled.bind(this);
        this.isJobDisabled = this.isJobDisabled.bind(this);
        this.onNavigate_Click = this.onNavigate_Click.bind(this);
        this.quoteStatus_Change = this.quoteStatus_Change.bind(this);
        this.jobStatus_Change = this.jobStatus_Change.bind(this);
        this.onSelectCrew = this.onSelectCrew.bind(this);
        this.onSelectCrewDay = this.onSelectCrewDay.bind(this);
        this.onNoParkingChange = this.onNoParkingChange.bind(this);
        this.onNoParkingDateSelected = this.onNoParkingDateSelected.bind(this);
        this.subJobNavigate = this.subJobNavigate.bind(this);
        this.clearLock = this.clearLock.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.refreshToken = this.refreshToken.bind(this);
        this.toolbar_onSaveClick = this.toolbar_onSaveClick.bind(this);
        this.selectedDaysTemplate = this.selectedDaysTemplate.bind(this);
        this.toolbar_onBackClick = this.toolbar_onBackClick.bind(this);
        this.dialog_OkClick = this.dialog_OkClick.bind(this);
        this.onStartTimeChange = this.onStartTimeChange.bind(this);
        this.onEndTimeChange = this.onEndTimeChange.bind(this);
        this.onSelectAllDays = this.onSelectAllDays.bind(this);
    }

    /** */
    private initializeState(): void {
        Yup.addMethod(Yup.string, 'checkDuplicate', function validateEstimate() {
            return this.test('estimate-duplicate', 'Estimate must be unique', function(value) {
                return new Promise((resolve, reject) => {
                    if(value === 'Test') {
                        reject('Estimate must be unique');
                    }
                    resolve(true);
                });
            });
        });
        //  Page
        const page: MPageProps = {locked: false};

        const data: Request = {
            id: '',
            estimate: '',
            additionalRef: '',
            locked: false,
            requestor: '',
            exchange: '',
            slaType: 0,
            projectValue: 0,
            quoteStatus: 0,
            quoteCompleteDate: null,
            workStream: 3,
            costClaimable: 0,
            quoteValue: 0,
            jobPriority: -1,
            jobType: [],
            jobDetail: '',
            jobStatus: 0,
            workDescription: '',
            estimatedDays: 0,
            address1: '',
            address2: '',
            address3: '',
            city: '',
            county: '',
            postcode: '',
            northing: 0,
            easting: 0,
            gridReference: '',
            dueDate: new Date(),
            slipNumber: '',
            jobStartDate: null,
            endType: 0,
            jobEndDate: null,
            selectedDays: [],
            noParkingRequired: false,
            weekendWorks: false,
            busStop: -1,
            dayOnly: false,
            civilsName: '',
            civilsEmail: '',
            civilsPhone: '',
            siteDocsComplete: false,
            invoiceNumber: '',
            parent: '',
            submittedDate: null,
            createdOn: null,
            addRecipients: '',
            permitRef: '',
            permitStatus: -1,
            drawingRef: '',
            resources: [],
            commercialStatus: 0,
            externalInvoicesReceived: 0,
            jobCompletedDate: null,
            commercialCompleteDate: null,
            dfeStatus: 0,
            worksTotalCost: 0,
            uplift: 0,
            dfeValue: 0,
            dfePartialReason: 0,
            dfePartialInfo: '',
            sentToDepotnet: false,
            actualCost: 0,
            drawingsBy: []
        };
        
        this.state = {
            pageTitle: '',
            pageSubtitle: '',
            page: page,
            form: {
                id: 'commercialForm',
                data: data,
                validationSchema: this.quoteValidationSchema,
            },
            pageActions: PageActions.None,
            projectList: []
        };

    }

    public componentDidMount(): void {
        window.addEventListener("unload", this.onUnload);
        this.m_interval = setInterval(this.refreshToken, 1000);
    }

    public componentWillUnmount(): void {
        clearInterval(this.m_interval);
        window.removeEventListener("unload", this.onUnload);
        this.clearLock();
    }

    public async refreshToken(): Promise<void> {
        //refresh lock Token
        if((Date.now() - this.m_lockDate.getTime()) > 5000)
        {
            await this.m_lockClient.call(
                (client) => client.create(new CreateLockRequest(
                    {
                        itemId: this.state.form.data.id
                    })
                ));
            this.m_lockDate = new Date();
        }
    }

    private async onUnload(): Promise<void> {
        await this.clearLock();
    }

    private async clearLock(): Promise<void> {
        if(this.state.form.data.id !== ''){
            await this.m_lockClient.call(client => client.delete(new CreateLockRequest(
                {
                    itemId: this.state.form.data.id
                })
            ));
        }
    }

    private form_onBeforeSubmit(fieldValues: Request, formikHelpers: FormikHelpers<Request>): boolean {
        this.safeSetState(draft => draft.pageActions !== PageActions.Saving);
        return false;
    }

    private async form_onSubmit(fieldValues: Request, formikHelpers: FormikHelpers<Request>): Promise<void> {
        const updateRequest = new UpdateRequestRequest({
            id: fieldValues.id,
            estimate: fieldValues.estimate,
            additionalRef: fieldValues.additionalRef,
            exchange: fieldValues.exchange,
            slaType: fieldValues.slaType,
            projectValue: fieldValues.projectValue,
            quoteStatus: fieldValues.quoteStatus,
            workStream: fieldValues.workStream,
            costClaimable: fieldValues.costClaimable,
            quoteValue: fieldValues.quoteValue,
            jobPriority: fieldValues.jobPriority,
            jobType: fieldValues.jobType,
            jobDetail: fieldValues.jobDetail,
            workDescription: fieldValues.workDescription,
            estimatedDays: fieldValues.estimatedDays,
            address1: fieldValues.address1,
            address2: fieldValues.address2,
            address3: fieldValues.address3,
            city: fieldValues.city,
            county: fieldValues.county,
            postcode: fieldValues.postcode,
            northing: fieldValues.northing,
            easting: fieldValues.easting,
            gridReference: fieldValues.gridReference,
            dueDate: fieldValues.dueDate ?? new Date(),
            slipNumber: fieldValues.slipNumber,
            jobStartDate: fieldValues.jobStartDate ?? undefined,
            endType: fieldValues.endType ?? 0,
            jobEndDate: fieldValues.jobEndDate ?? undefined,
            selectedDays: fieldValues.selectedDays ?? undefined,
            noParkingRequired: fieldValues.noParkingRequired,
            weekendWorks: fieldValues.weekendWorks,
            busStop: fieldValues.busStop,
            dayOnly: fieldValues.dayOnly,
            civilsName: fieldValues.civilsName,
            civilsEmail: fieldValues.civilsEmail,
            civilsPhone: fieldValues.civilsPhone,
            siteDocsComplete: fieldValues.siteDocsComplete,
            invoiceNumber: fieldValues.invoiceNumber,
            jobStatus: fieldValues.jobStatus,
            addRecipients: fieldValues.addRecipients?.trim().toLowerCase() ?? '',
            permitRef: fieldValues.permitRef,
            permitStatus: fieldValues.permitStatus,
            commercialStatus: fieldValues.commercialStatus,
            dfeStatus: fieldValues.dfeStatus,
            uplift: fieldValues.uplift,
            dfeValue: fieldValues.dfeValue,
            sentToDepotnet: fieldValues.sentToDepotnet,
            actualCost: fieldValues.actualCost
        });

        const result = await this.m_requestClient.callWithReply(RequestReply, (client => client.update(updateRequest)));
        result.throwIfFailed();

        const dfeRequest = new UpdateDfeDataRequest({
            requestId: fieldValues.id,
            reason: fieldValues.dfePartialReason ?? -1,
            information: fieldValues.dfePartialInfo
        });
        const dfeResult = await this.m_dfeDataClient.callWithReply(RequestReply, (client => client.update(dfeRequest)));
        dfeResult.throwIfFailed();

        //Clear dirty flag.
        formikHelpers.resetForm();
    }

    private async form_onAfterSubmit(outcome: MFormOutcome, fieldValues: Request, formikHelpers: FormikHelpers<Request>, exception: any | undefined): Promise<void> {
        if(fieldValues.noParkingRequired && !this.state.form.data.noParkingRequired) {
            //Add new job assignment for installing no parking cones.
            await this.m_jobAssignClient.call(client =>
                (client.addAdditionalWork(new AddAdditionalWorkRequest({
                    requestId: this.state!.form.data.id,
                    workItemDate: this.m_noParkingInstall,
                    itemNote: 'Install No Parking Cones'
            }))));
        }

        if(outcome === 'success') {
            this.m_pageRef.current!.messageBar.success(`Save complete.`);
        }
        this.safeSetState(draft => draft.pageActions = PageActions.None);

        await this.loadPageData();
        await this.m_jobCrewRef.current?.refresh();
    }

    private form_onError(exception: any): boolean
    {
        const handled = false;
        this.m_pageRef.current!.messageBar.error(toErrorMessage(exception));
        return handled;
    }

    private async loadPageData(): Promise<void> {
        const id = this.props.match.params.id;

        //Pull request data
        const result = await this.m_requestClient.callWithReply(RequestReply, (client) => client.get(id));
        result.throwIfFailed();

        result.reply!.request!.costClaimable = result.reply!.request!.costClaimable ?? 0;
        result.reply!.request!.jobType = result.reply!.request!.jobType ?? 0;
        result.reply!.request!.gridReference = result.reply!.request!.gridReference ?? '';
        result.reply!.request!.siteDocsComplete = result.reply!.request!.siteDocsComplete ?? false;

        const projectResult = await this.m_projectClient.callWithReply(ProjectMultiReply, (client) => client.getAll());
        projectResult.throwIfFailed();

        this.safeSetState((draft: State) => {

            draft.pageTitle = 'Commercial View';
            draft.pageSubtitle = `Commercial View: ${result.reply!.request!.estimate}`;
            draft.form.data = result.reply!.request!;
            draft.projectList = projectResult.reply!.projects;

        });
        this.m_locationValue = result.reply!.request!.gridReference;
    }

    private toolbar_onBackClick(): void {
        if(this.m_formRef.current?.getIsDirty()) {
            this.m_okCancelDialogRef.current!.show(
                'Data Changed',
                `Data has been changed but not saved. Do you still wish to exit?`,
                MSuccessIcon
            );
            return;
        }

        this.props.history.goBack();
    }

    private dialog_OkClick(): void {
        this.props.history.goBack();
    }

    /** */
    private async toolbar_onRefreshClick(): Promise<void> {

        this.safeSetState((draft: State) => {
            draft.pageActions |= PageActions.Refreshing;
        });

        try {
            await this.loadPageData();
        } finally {

            this.safeSetState((draft: State) => {
                draft.pageActions &= ~PageActions.Refreshing;
            });
        }
    }

    private async toolbar_onSaveClick(): Promise<void> {
        await this.m_formRef.current!.submit();
        if(!(await this.m_formRef.current!.validate())) {
            this.m_messageDialogRef.current!.show("Validation Error",
                "The form data is invalid. Please correct any field (red) errors before saving.");
        }
    }

    private async page_onLoadData(): Promise<void> {
        return this.loadPageData()
    }

    /** */
    private getToolbarTemplate(): ReactElement<MToolbar> {

        return (
            <MToolbar>
                <MButton label="Back"
                         color="secondary"
                         iconOnly={true}
                         icon={MBackIconName}
                         tooltip="Go Back"
                         disabled={false}
                         onClick={this.toolbar_onBackClick}/>
                <MSpacer/>
                <MButton label="Save"
                         color="success"
                         iconOnly={true}
                         icon={MSaveIconName}
                         tooltip="Save"
                         disabled={this.isFormDisabled}
                         isBusy={this.isSaving}
                         onClick={this.toolbar_onSaveClick}/>
            </MToolbar>
        );

    }

    private async close_Click(): Promise<void> {
        this.props.history.goBack();
    }

    private async quoteStatus_Change(newValue: MNullable<number>): Promise<void> {
        if(newValue === 2) { //On Hold
            this.m_noteListRef.current?.requestNote('Please enter information requirement.', true);
        } else if(newValue === 5) { //Cancelled
            this.m_noteListRef.current?.requestNote('Please enter cancellation reason.', true);
        }
    }

    private async jobStatus_Change(newValue: MNullable<number>): Promise<void> {
        if(newValue === 9) { //Cancelled
            this.m_cancelDialogRef.current?.show();
        }
    }

    private isNavigateDisabled(): boolean{
        if(this.m_locationValue !== null){
            return !this.m_locationValue.match(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}([-a-zA-Z0-9@:%_,.~#?&|//=]*)$/g);
        }

        return true;
    }

    private isQuoteDisabled(): boolean {
        const allowedRoles: string[] = ['Quotation', 'Supervisor'];
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const access = allowedRoles.some(a => roles?.includes(a));

        return this.state.form.data.quoteStatus === 3
            || !access
            || this.isFormDisabled;
    }

    private isJobDisabled(): boolean {
        const allowedRoles: string[] = ['Booking', 'Supervisor'];
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const access = allowedRoles.some(a => roles?.includes(a));

        return !access
            || this.isFormDisabled;
    }

    private onNavigate_Click(): void {
        window.open(this.m_locationValue, '_blank', 'noopener,noreferrer');
    }

    private async onSelectCrew(): Promise<void> {
        const requestId = encodeURIComponent(this.state.form.data.id);
        const startString = encodeURIComponent(this.state.form.data.jobStartDate!.toISOString());
        const endString = encodeURIComponent(this.state.form.data.jobEndDate!.toISOString());

        if(await this.m_formRef.current!.validate()) {
            await this.m_formRef.current!.submit();
            this.props.navigate(`/crews?requestId=${requestId}&startDate=${startString}&endDate=${endString}`);
        } else {
            this.m_messageDialogRef.current!.show("Validation Error",
                "The form data is invalid and must be corrected before assigning a crew.");
        }
    }

    private async onSelectCrewDay(date: Date): Promise<void> {
        const requestId = encodeURIComponent(this.state.form.data.id);
        const dateString = encodeURIComponent(date.toISOString());

        if(await this.m_formRef.current!.validate()) {
            await this.m_formRef.current!.submit();
            this.props.navigate(`/crews?requestId=${requestId}&startDate=${dateString}&endDate=${dateString}`);
        } else {
            this.m_messageDialogRef.current!.show("Validation Error",
                "The form data is invalid and must be corrected before assigning a crew. Check all fields to see highlighted errors.");
        }
    }

    private onSelectedDaysChange(fieldProps: FieldProps, selectedDays: Date[] | undefined) {
        let weekendWorks: boolean = false;
        selectedDays?.forEach(d => {
            if(d.getDay() === 0 || d.getDay() === 6) { weekendWorks = true; }
        });

        if(selectedDays !== null){
            selectedDays = selectedDays!.sort((A, B) => A < B ? -1 : A > B ? 1 : 0);
        }

        fieldProps.form.setFieldValue('selectedDays', selectedDays);
        fieldProps.form.setFieldValue('weekendWorks', weekendWorks);
    }

    private onSelectAllDays(fieldProps: FieldProps): void {
        let selectedDays: Date[] = [];
        let currentDate = new Date(fieldProps.form.values.jobStartDate);
        const lastDate = new Date(fieldProps.form.values.jobEndDate);

        while(currentDate <= lastDate) {
            selectedDays.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        fieldProps.form.setFieldValue('selectedDays', selectedDays);
    }

    private onStartTimeChange(fieldProps: FieldProps, newDate: Date | undefined) {
        let daysSelected = false;
        if((newDate?.getHours() ?? 0) >= 6 && (newDate?.getHours() ?? 0) < 18) {
            daysSelected = true;
        }

        //filter days so any outside the new selection can be removed.
        let searchDate = new Date(newDate!);
        searchDate!.setHours(0, 0, 0, 0);
        const filteredDays = (fieldProps.form.values.selectedDays as Date[]).filter(d => d >= newDate!);

        fieldProps.form.setFieldValue('dayOnly', daysSelected);
        fieldProps.form.setFieldValue('jobStartDate', newDate!);
        fieldProps.form.setFieldValue('selectedDays', filteredDays.sort((A, B) => A < B ? -1 : A > B ? 1 : 0));
    }

    private onEndTimeChange(fieldProps: FieldProps, newDate: Date | undefined) {
        //filter days so any outside the new selection can be removed.
        let searchDate = new Date(newDate!);
        searchDate!.setHours(23, 59, 59, 999);
        const filteredDays = (fieldProps.form.values.selectedDays as Date[]).filter(d => d <= newDate!);

        fieldProps.form.setFieldValue('jobEndDate', newDate!);
        fieldProps.form.setFieldValue('selectedDays', filteredDays.sort((A, B) => A < B ? -1 : A > B ? 1 : 0));
    }

    private onNoParkingChange(newValue: MNullable<boolean>): void {
        if((newValue ?? false) && !this.state.form.data.noParkingRequired) {
            //No parking cones have been activated so get install date from user.
            this.m_noParkingDialogRef.current!.show();
        }
    }

    private onNoParkingDateSelected(fieldProps: FieldProps,  selectedDate: Date | undefined) {
        this.m_noParkingInstall = selectedDate;

        //Reset the no parking selection if no date is selected.
        if(selectedDate === undefined) {
            fieldProps.form.setFieldValue('noParkingRequired', false);
        }
    }

    private onDfeStatusChange(fieldProps: FieldProps, newValue: MNullable<number>): void {
        if(newValue !== 7){
            fieldProps.form.setFieldValue('dfePartialReason', -1);
            fieldProps.form.setFieldValue('dfePartialInfo', '');
        }
    }

    private async subJobNavigate(newJob: boolean, id: string = '', subJobCount: number = 0): Promise<void> {
        const subCountText = (Number(subJobCount) + 1).toString().padStart(2, '0');
        if(newJob) {
            const createRequest = new CreateRequestRequest({
                estimate: this.state.form.data.estimate + `-S${subCountText}`,
                additionalRef: '',
                requestor: this.props.msalContext.accounts[0].name,
                exchange: this.state.form.data.exchange,
                slaType: this.state.form.data.slaType,
                projectValue: this.state.form.data.projectValue,
                workStream: this.state.form.data.workStream,
                workDescription: this.state.form.data.workDescription,
                estimatedDays: 0,
                address1: this.state.form.data.address1,
                address2: this.state.form.data.address2,
                address3: this.state.form.data.address3,
                city: this.state.form.data.city,
                county: this.state.form.data.county,
                postcode: this.state.form.data.postcode,
                northing: this.state.form.data.northing,
                easting: this.state.form.data.easting,
                gridReference: this.state.form.data.gridReference,
                parent: this.state.form.data.id
            });

            const result = await this.m_requestClient.callWithReply(RequestReply, (client => client.create(createRequest)));
            result.throwIfFailed();

            this.props.navigate(`/requests/create/${result.reply!.request!.id}`);
        } else {
            this.props.navigate(`/requests/${id}`);
            window.location.reload();
        }
    }

    private async cancelDialogClose(fieldProps: FieldProps, noteData: string, cancel: boolean): Promise<void> {
        if(cancel){
            //Restore the old status value;
            fieldProps.form.setFieldValue('jobStatus', this.state.form.data.jobStatus);
        } else {
            const createResult = await this.m_noteClient.callWithReply(
                NoteReply, (client) => client.create(new CreateNoteRequest({
                    requestId: this.state.form.data.id,
                    noteText: noteData
                })));
            createResult.throwIfFailed();
            await this.m_noteListRef.current!.refresh();
        }
    }

    private selectedDaysTemplate(): string{
        const selectedDays = this.state.form.data.selectedDays;
        const dayArray: string[] = [];

        selectedDays.forEach(d => {
            const dayName = d.toLocaleDateString('en-GB', { weekday: 'short' });
            if(!dayArray.includes(dayName)) {
                dayArray.push(dayName);
            }
        });

        return dayArray.join(', ');
    }

    /** */
    public render(): ReactElement {

        const yesNoList: MDropDownItem<boolean>[] = [{label: 'No', value: false},{label: 'Yes', value: true}];
        const shiftPatternList: MDropDownItem<boolean>[] = [{label: 'Nights', value: false},{label: 'Days', value: true}];

        return (
            <MPage title={this.state.pageTitle}
                   subtitle={this.state.pageSubtitle}
                   locked={this.state.page.locked}
                   width={12}
                   toolbar={this.getToolbarTemplate()}
                   onLoadData={this.page_onLoadData}
                   ref={this.m_pageRef}>

                <OkCancelDialog ref={this.m_okCancelDialogRef}
                                okClicked={this.dialog_OkClick}
                />
                <EmailConfirmDialog ref={this.m_emailConfirmRef}/>
                <MessageDialog ref={this.m_messageDialogRef}/>

                <div style={{position: "fixed", left: 0, width: "66%", top: "200px", padding: "0 2rem"}}>
                    <div style={{overflowY: "scroll", overflowX: "hidden", maxHeight: 'calc(100vh - 260px)'}}>
                        <MForm formId={this.state.form.id}
                               initialValues={this.state.form.data}
                               validationSchema={this.state.form.validationSchema}
                               onBeforeSubmit={this.form_onBeforeSubmit}
                               onSubmit={this.form_onSubmit}
                               onAfterSubmit={this.form_onAfterSubmit}
                               onError={this.form_onError}
                               ref={this.m_formRef}
                        >

                            <div className="formgrid grid">
                                <div className="col-12">

                                    <MFormSection title="General">
                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Estimate"
                                                               fieldName="estimate">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.EstimateMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={true}
                                                                  className={fieldClasses}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Requestor"
                                                               fieldName="requestor">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.RequestorMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={true}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Exchange"
                                                               fieldName="exchange">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MAutoComplete id={fieldProps.field.name}
                                                                       fieldProps={fieldProps}
                                                                       disabled={false}
                                                                       className={fieldClasses}
                                                                       suggestions={this.context?.enums === null ? [] : this.context?.enums.exchangeList.map(e => e.name)}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Additional Ref"
                                                               fieldName="additionalRef">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.AdditionalRefMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Project Code"
                                                               fieldName="projectValue">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={this.isFormDisabled}
                                                                           fieldProps={fieldProps}
                                                                           items={this.state.projectList.map(project => ({
                                                                               value: project.id,
                                                                               label: project.code + ' - ' + project.name
                                                                           }))}
                                                                           initialValue={0}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Type Of Works"
                                                               fieldName="workStream">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={this.isFormDisabled}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.workStreams.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={0}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Estimated Days"
                                                               fieldName="estimatedDays">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={5}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isQuoteDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'SLA'}
                                                               fieldName={'slaType'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<number> id="ProjectSelection"
                                                                           disabled={true}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.slaTypes.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={0}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label="WorkDescription"
                                                               fieldName="workDescription">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextArea id={fieldProps.field.name}
                                                                  maxLength={Request.WorkDescriptionMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}
                                                                   rows={5}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label="Additional E-mail addresses"
                                                               fieldName={'addRecipients'}>

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextArea id={'addresses'}
                                                                   maxLength={Request.AddRecipientsMaxLength}
                                                                   readonly={false}
                                                                   fieldProps={fieldProps}
                                                                   disabled={this.isFormDisabled}
                                                                   className={fieldClasses}
                                                                   rows={5}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>
                                    </MFormSection>

                                    <Divider/>

                                    <MFormSection title="Commercial">

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Commercial Status"
                                                               fieldName="commercialStatus">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={this.isFormDisabled}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.commercial.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={0}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Uplift Value"
                                                               fieldName="uplift">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={9}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isFormDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={2}
                                                                     mode={'currency'}
                                                                     currency={'GBP'}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Actual Cost"
                                                               fieldName="actualCost">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={9}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isFormDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={2}
                                                                     mode={'currency'}
                                                                     currency={'GBP'}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                    </MFormSection>

                                    <MFormSection>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="DFE Value"
                                                               fieldName="dfeValue">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={9}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isFormDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={2}
                                                                     mode={'currency'}
                                                                     currency={'GBP'}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="DFE Status"
                                                               fieldName="dfeStatus">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={this.isFormDisabled}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.dfeStatuses.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={0}
                                                                           onChange={e => this.onDfeStatusChange(fieldProps, e)}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="DFE Partial Reason"
                                                               fieldName="dfePartialReason">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={fieldProps.form.values.dfeStatus !== 7}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.dfePartialReasons.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={-1}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label="DFE Partial Information"
                                                               fieldName="dfePartialInfo">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.AdditionalRefMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={fieldProps.form.values.dfeStatus !== 7}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                    </MFormSection>

                                    <Divider/>

                                    <MFormSection title="Quotation">

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Status"
                                                               fieldName="quoteStatus">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={this.isQuoteDisabled}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.quoteStatuses.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={0}
                                                                           onChange={this.quoteStatus_Change}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Cost Claimable"
                                                               fieldName="costClaimable">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={this.isQuoteDisabled}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.costTypes.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={0}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Quote Value"
                                                               fieldName="quoteValue">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={9}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isQuoteDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={2}
                                                                     mode={'currency'}
                                                                     currency={'GBP'}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="TM Type"
                                                               fieldName="jobType">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={this.isQuoteDisabled}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.jobTypes.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={0}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-8">
                                            <MFormFieldControl label="TM Detail"
                                                               fieldName="jobDetail">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.JobDetailMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                    </MFormSection>

                                    {this.state.form.data.jobStatus > 0 && <Divider/>}
                                    {this.state.form.data.jobStatus > 0 &&
                                        <MFormSection title="Job Data">
                                            <div className="col-12 md:col-3">
                                            <MFormFieldControl label="DFE Slip Number"
                                                               fieldName="slipNumber">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.SlipNumberMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isJobDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>
                                            <div className="col-12 md:col-4">
                                                <MFormFieldControl label={'Priority'}
                                                                   fieldName={'jobPriority'}>
                                                    {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                        return (
                                                            <React.Fragment>
                                                                <MDropDown<number> id={fieldProps.field.name}
                                                                                   disabled={true}
                                                                                   fieldProps={fieldProps}
                                                                                   items={this.context?.enums === null ? [] : this.context?.enums.jobPriority.map((enumvalue) => {
                                                                                       return {label: enumvalue.name, value: enumvalue.id};
                                                                                   })}
                                                                                   className={fieldClasses}
                                                                                   initialValue={0}
                                                                />
                                                            </React.Fragment>
                                                        );
                                                    }}
                                                </MFormFieldControl>
                                            </div>
                                        </MFormSection>}

                                    {this.state.form.data.jobStatus > 0 && <MFormSection>
                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'Start Date'} fieldName={'jobStartDate'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MCalendar id={fieldProps.field.name}
                                                                   fieldProps={fieldProps}
                                                                   disabled={true}
                                                                   className={fieldClasses}
                                                                   showTime={true}
                                                                   hourFormat={'24'}
                                                                   onChange={(newDate: Date | undefined) =>  this.onStartTimeChange(fieldProps, newDate)}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                            <div className="col-12 md:col-2">
                                                <MFormFieldControl label={'Work Start Time'} fieldName={'jobStartDate'}>
                                                    {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                        return (
                                                            <MCalendar id={fieldProps.field.name}
                                                                       fieldProps={fieldProps}
                                                                       disabled={true}
                                                                       className={fieldClasses}
                                                                       showTime={true}
                                                                       timeOnly={true}
                                                                       showButtonBar={false}
                                                                       hourFormat={'24'}
                                                            />
                                                        );
                                                    }}
                                                </MFormFieldControl>
                                            </div>

                                            <div className="col-12 md:col-2">
                                                <MFormFieldControl label={'End Type'}
                                                                   fieldName={'endType'}>
                                                    {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                        return (
                                                            <React.Fragment>
                                                                <MDropDown<number> id={fieldProps.field.name}
                                                                                   disabled={true}
                                                                                   fieldProps={fieldProps}
                                                                                   items={[{label: 'End Date', value: 0},{label: 'In Situ', value: 1}]}
                                                                                   className={fieldClasses}
                                                                                   initialValue={0}
                                                                />
                                                            </React.Fragment>
                                                        );
                                                    }}
                                                </MFormFieldControl>
                                            </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'End Date'} fieldName={'jobEndDate'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MCalendar id={fieldProps.field.name}
                                                                   fieldProps={fieldProps}
                                                                   disabled={true}
                                                                   className={fieldClasses}
                                                                   showTime={false}
                                                                   hourFormat={'24'}
                                                                   onChange={(newDate) => this.onEndTimeChange(fieldProps, newDate)}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                            <div className="col-12 md:col-2">
                                                <MFormFieldControl label={'Work End Time'} fieldName={'jobEndDate'}>
                                                    {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                        return (
                                                            <MCalendar id={fieldProps.field.name}
                                                                       fieldProps={fieldProps}
                                                                       disabled={true}
                                                                       className={fieldClasses}
                                                                       showTime={true}
                                                                       timeOnly={true}
                                                                       showButtonBar={false}
                                                                       hourFormat={'24'}
                                                            />
                                                        );
                                                    }}
                                                </MFormFieldControl>
                                            </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label={'Selected Days'} fieldName={'selectedDays'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <React.Fragment>
                                                            <MCalendarMulti
                                                                id={fieldProps.field.name}
                                                                fieldProps={fieldProps}
                                                                disabled={true}
                                                                className={fieldClasses}
                                                                minDate={fieldProps.form.values.jobStartDate ?? undefined}
                                                                maxDate={fieldProps.form.values.jobEndDate ?? undefined}
                                                                onChange={(newDates: Date[] | undefined) =>  this.onSelectedDaysChange(fieldProps, newDates)}
                                                            />
                                                            <MSpacer/>
                                                            <Button
                                                                disabled={true}
                                                                label={'All'}
                                                                tooltip={'Select all days in range'}
                                                                onClick={e => this.onSelectAllDays(fieldProps)}
                                                            />
                                                        </React.Fragment>

                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'No Parking Cones'}
                                                               fieldName={'noParkingRequired'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <React.Fragment>
                                                            <NoParkingDialog ref={this.m_noParkingDialogRef}
                                                                             onDateSelected={(newValue: Date | undefined) =>
                                                                                 this.onNoParkingDateSelected(fieldProps, newValue)}
                                                            />
                                                            <MDropDown<boolean> id='noParkingRequired'
                                                                                disabled={this.isJobDisabled}
                                                                                fieldProps={fieldProps}
                                                                                items={yesNoList}
                                                                                initialValue={false}
                                                                                onChange={this.onNoParkingChange}
                                                            />
                                                        </React.Fragment>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'Bus Stop Suspension'}
                                                               fieldName={'busStop'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<number> id='busStop'
                                                                            disabled={this.isJobDisabled}
                                                                            fieldProps={fieldProps}
                                                                            items={this.context?.enums === null ? [] : this.context?.enums.busStopValues.map((enumvalue) => {
                                                                                return {label: enumvalue.name, value: enumvalue.id};
                                                                            })}
                                                                            initialValue={-1}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'Weekend Works'}
                                                               fieldName={'weekendWorks'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<boolean> id='weekendWorks'
                                                                            disabled={true}
                                                                            fieldProps={fieldProps}
                                                                            items={yesNoList}
                                                                            initialValue={false}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'Shift Pattern'}
                                                               fieldName={'dayOnly'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<boolean> id='dayOnly'
                                                                            disabled={true}
                                                                            fieldProps={fieldProps}
                                                                            items={shiftPatternList}
                                                                            initialValue={false}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                            <div className="col-12 md:col-12">
                                                <MFormFieldControl label="Permit Reference(s)"
                                                                   fieldName="permitRef">

                                                    {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                        return (
                                                            <MTextArea id={fieldProps.field.name}
                                                                       maxLength={Request.PermitRefMaxLength}
                                                                       readonly={false}
                                                                       fieldProps={fieldProps}
                                                                       disabled={this.isFormDisabled}
                                                                       className={fieldClasses}
                                                                       rows={3}/>
                                                        );

                                                    }}

                                                </MFormFieldControl>
                                            </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'Permit Status'}
                                                               fieldName={'permitStatus'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                            disabled={this.isFormDisabled}
                                                                            fieldProps={fieldProps}
                                                                            items={this.context?.enums === null ? [] : this.context?.enums.permitStatuses.map((enumvalue) => {
                                                                                return {label: enumvalue.name, value: enumvalue.id};
                                                                            })}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>
                                        </MFormSection>}

                                    {this.state.form.data.jobStatus > 0 &&
                                        <MFormSection>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Civils Name"
                                                               fieldName="civilsName">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.CivilsNameMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Civils Email"
                                                               fieldName="civilsEmail">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.CivilsEmailMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Civils Phone"
                                                               fieldName="civilsPhone">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.CivilsPhoneMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Booking Status"
                                                               fieldName="jobStatus">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <React.Fragment>
                                                            <CancellationDialog ref={this.m_cancelDialogRef}
                                                                                onDialogClose={(data, cancel) => this.cancelDialogClose(fieldProps, data, cancel)}/>
                                                            <MDropDown<number> id={fieldProps.field.name}
                                                                               disabled={true}
                                                                               fieldProps={fieldProps}
                                                                               items={this.context?.enums === null ? [] : this.context?.enums.jobStatuses.map((enumvalue) => {
                                                                                   return {label: enumvalue.name, value: enumvalue.id};
                                                                               })}
                                                                               initialValue={0}
                                                                               onChange={this.jobStatus_Change}
                                                            />
                                                        </React.Fragment>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label={'Site Docs (Required to Complete Job)'}
                                                               fieldName={'siteDocsComplete'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<boolean> id={fieldProps.field.name}
                                                                            disabled={this.isJobDisabled}
                                                                            fieldProps={fieldProps}
                                                                            items={yesNoList}
                                                                            initialValue={false}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label={'Copied to Depotnet'}
                                                               fieldName={'sentToDepotnet'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<boolean> id={fieldProps.field.name}
                                                                            disabled={this.isJobDisabled}
                                                                            fieldProps={fieldProps}
                                                                            items={yesNoList}
                                                                            initialValue={false}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                    </MFormSection>}

                                    <Divider/>

                                    <MFormSection title="Crew Assignments">
                                        <div className={"col-12 md:col-12"}>
                                            <JobCrewsControl ref={this.m_jobCrewRef}
                                                             parentId={this.props.match.params.id}
                                                             msalContext={this.props.msalContext}
                                                             selectCrew={this.onSelectCrew}
                                                             selectDay={this.onSelectCrewDay}
                                                             jobStatus={this.state.form.data.jobStatus}
                                            />
                                        </div>
                                    </MFormSection>

                                    <Divider/>

                                    <MFormSection title="Drawings">
                                        <div className="col-12 md:col-12">
                                            <DrawingControl parentId={this.props.match.params.id}
                                                            msalContext={this.props.msalContext}
                                                            baseDrawingRef={this.state.form.data.drawingRef}
                                            />
                                        </div>
                                    </MFormSection>

                                    <Divider/>

                                    <MFormSection title="Files">
                                        <div className="col-12 md:col-12">
                                            <FileListControl parentId={this.props.match.params.id}
                                                             msalContext={this.props.msalContext}
                                                             selectionOnly={false}
                                            />
                                        </div>
                                    </MFormSection>

                                    <Divider/>

                                    <MFormSection title="Purchase Orders">
                                        <div className="col-12 md:col-12">
                                            <InvoiceControl parentId={this.props.match.params.id}
                                                            msalContext={this.props.msalContext}
                                            />
                                        </div>
                                    </MFormSection>

                                    <Divider/>

                                    <MFormSection title="Location">

                                        <div className="col-12 md:col-6">
                                            <MFormFieldControl label="Easting"
                                                               fieldName="easting">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={8}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isFormDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={0}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <MFormFieldControl label="Northing"
                                                               fieldName="northing">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={8}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isFormDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={0}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label="Grid Reference URL"
                                                               fieldName="gridReference">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <React.Fragment>
                                                            <MTextBox id={fieldProps.field.name}
                                                                      maxLength={300}
                                                                      fieldProps={fieldProps}
                                                                      disabled={this.isFormDisabled}
                                                                      className={fieldClasses}
                                                                      onChange={e => this.m_locationValue = e.toString()}
                                                            />
                                                            <MButton
                                                                tooltip={'Browse address'}
                                                                icon={'pi pi-compass'}
                                                                disabled={this.isNavigateDisabled}
                                                                onClick={this.onNavigate_Click}
                                                            />
                                                        </React.Fragment>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>
                                    </MFormSection>

                                    <MFormSection title="Address">
                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Address 1"
                                                               fieldName="address1">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.Address1MaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Address 2"
                                                               fieldName="address2">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.Address2MaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Address 3"
                                                               fieldName="address3">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.Address3MaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="City"
                                                               fieldName="city">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.CityMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="County"
                                                               fieldName="county">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.CountyMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Postcode"
                                                               fieldName="postcode">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.PostcodeMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>
                                    </MFormSection>

                                </div>
                            </div>

                        </MForm>
                    </div>
                </div>

                <div style={{position: "fixed", left: "65%", width: "35%", top: "200px", padding: "0 0rem"}}>
                    <div style={{overflowY: "scroll", overflowX: "hidden", maxHeight: 'calc(100vh - 260px)'}}>
                        <MFormSection title="Notes">
                            <div className="col-12 md:col-12">
                                <NoteListControl parentId={this.props.match.params.id}
                                                 msalContext={this.props.msalContext}
                                                 ref={this.m_noteListRef}
                                />
                            </div>
                        </MFormSection>

                        <Divider/>

                        <MFormSection title="Audit">
                            <div className="col-12 md:col-12">
                                <AuditLogControl parentId={this.props.match.params.id}
                                                 msalContext={this.props.msalContext} />
                            </div>
                        </MFormSection>
                    </div>
                </div>

            </MPage>

        );

    }

    private get isFormDisabled(): boolean{
        return this.isSaving;
    }

    private get isExecutingAction(): boolean {
        return this.state.pageActions !== PageActions.None;
    }

    /** */
    private get isSaving() {
        return (this.state.pageActions & PageActions.Saving) === PageActions.Saving;
    }

    private get isRefreshing() {
        return (this.state.pageActions & PageActions.Refreshing) === PageActions.Refreshing;
    }
}

export default withMsal(withRouter(EditCommercialPage));
